export const KEY_CODES = {
    enter: 'Enter'
};
